import * as React from 'react';

import { EmptyField, TextField } from '../../../../../../components/Field/common';
import { useOfferContext } from '../../../../../../utils/offerContext';

type TAreaType = 'kitchen' | 'living' | 'total';

interface IAreaFieldContainerProps {
  type: TAreaType;
}

export const AreaFieldContainer: React.FC<IAreaFieldContainerProps> = ({ type }) => {
  const { area, published } = useOfferContext();
  const displayArea = area && area[type];

  if (!displayArea) {
    return <EmptyField published={published} />;
  }

  return <TextField published={published}>{displayArea}</TextField>;
};
